import Select from "react-select";

const estadoOptions = ["Consumido", "Liquidado"].map(estado => ({
    value: estado,
    label: estado
}));

export default function EstadosSelect({ selectedEstado, setSelectedEstado }) {

    return (
        <Select
            options={estadoOptions}
            value={estadoOptions.find(opt => opt.value === selectedEstado)}
            onChange={(newEstado) => setSelectedEstado(newEstado.value)}
            placeholder="Seleccionar estado"
            styles={{
                control: (base, state) => ({
                    ...base,
                    borderColor: state.isFocused ? "#B04708" : "#ced4da",
                    boxShadow: state.isFocused
                        ? "0 0 0 1px #B04708"
                        : base.boxShadow,
                    outline: "none",
                    "&:hover": {
                        borderColor: state.isFocused ? "#B04708" : "#adadad",
                    },
                }),
                option: (base, state) => ({
                    ...base,
                    backgroundColor: state.isSelected
                        ? "#B04708"
                        : state.isFocused && !state.isDisabled
                            ? "#fff2f0ff"
                            : "white",
                    color: state.isDisabled
                        ? "#aaa"
                        : state.isSelected
                            ? "white"
                            : "#333",
                }),
            }}
        />
    );
}
